import React from 'react';
import '../../App.css';
import Profile from '../Profile';

function About() {
  return( 
    <>
        <Profile />
        <footer>
            &copy; Copyright All Rights Reserved 2021, Nicholas Sidharta
        </footer>
    </>
    );
}

export default About;
